<template>
  <div>
    <!-- Calendario vero e proprio -->
    <div class="wg-row grid-header">
      <div
        v-for="(num, index) in 7"
        :key="'grid-head-'+index"
        class="com-anm22-app-text-l wg-row day-of-week"
      >{{ $moment().isoWeekday(num).format('ddd').toUpperCase() }}</div>
    </div>
    <div class="vertical-height-div" style="height:5px;"></div>
    <div class="grid-container">
      <div v-for="(element, index) in monthMatrix" :key="'day-cell-'+index" class="grid-cell">
        <div
          :class="['wg-row', 'day-block', !element.day.isSame(month, 'month') ? 'other-month' : '']"
          @click="$emit('setDeliveryDate', element.day.utc().format('YYYY-MM-DD'))"
        >
          <div
            class="com-anm22-app-text-m"
            style="align-self:center;"
          >{{ element.day.format('DD') }}</div>
          <!-- Elenco consegne -->
          <div class="day-projects-div com-anm22-app-scrolling-panel">
            <div
              v-for="(row,index) in element.rows.sort((a,b) => a.priority - b.priority)"
              :key="element.day.format('D')+'-project-'+index"
              class="wg-row com-anm22-app-text-s project-label"
              :style="{ color: row.color }"
              :title="row.label"
            >{{ row.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    month: Object,
    active: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      docs: []
    };
  },
  computed: {
    monthMatrix() {
      let matrix = [];
      // prendo il primo giorno della settimana al cui interno di trova l'inizio del mese
      const firstDay = this.month
        .clone()
        .utc()
        .startOf("month")
        .startOf("isoWeek");
      const lastDay = this.month
        .clone()
        .utc()
        .endOf("month")
        .endOf("isoWeek");
      let selector = firstDay.clone();
      while (selector.isSameOrBefore(lastDay, "day")) {
        //Recupero i progetti con consegna questo giorno
        const rows = this.docs
          .filter(d =>
            this.$moment
              .unix(d.delivery.deliveryDate)
              .utc()
              .isSame(selector, "day")
          )
          .map(d => {
            const project = this.$store.getters["projects/get"](d.project);
            const label = this.getLabel(project, d);
            const color = this.getLabelColor(project, d);
            let priority = 0;
            if (label.includes("?")) {
              priority = 400;
            } else if (label.includes("*")) {
              priority = 300;
            } else if (project.category == 2) {
              priority = 200;
            } else {
              priority = 100;
            }
            return {
              label,
              color,
              priority
            };
          });
        //inserisco il giorno nella matrice
        matrix.push({
          day: selector.clone(),
          rows
        });
        //incremento il giorno
        selector.add(1, "days");
      }
      return matrix;
    }
  },
  methods: {
    getLabelColor(project, docs) {
      if (project.category == 2) {
        return "#ffca28";
      } else if (docs.data.company === "vrs") {
        return "#00af87";
      } else {
        return "red";
      }
    },
    getLabel(project, docs) {
      let string = "";
      // Simboli
      const tasks = this.$store.getters["tasks/getByProject"](
        project.idWorldProject
      );
      tasks.forEach(t => {
        if (t.name === "Finitura" && t.status === 3) {
          string += "*";
        }
        if (t.name === "Carta modello" && t.status === 3) {
          string += "!";
        }
        if (t.name === "Produzione" && t.status === 3) {
          string += "/";
        }
      });
      if (!docs.delivery.confirmed) {
        string += "?";
      }
      if (docs.graphics.printTreatment) {
        string += "$";
      }
      string += " ";
      // Nome cliente
      if (docs.data.firstName) {
        string += docs.data.firstName + " ";
      }
      if (docs.data.lastName) {
        string += docs.data.lastName + " ";
      }
      // Metodo di consegna
      if (docs.delivery.devliveryType) {
        switch (docs.delivery.devliveryType) {
          case "pickUp":
            string += "V ";
            break;
          case "call":
            string += "C ";
            break;
          case "shipping":
            string += "S ";
            break;
          default:
            string += docs.delivery.devliveryType.toUpperCase();
        }
      }
      string += project.name || "";
      string += project.projectId && project.name ? " - " : "";
      string += project.projectId || "";

      return string;
    }
  },
  created() {
    //Devo recuperare tutti i vircos-docs dei progetti per popolare il calendario
    this.$http
      .get("vircos/all")
      .then(response => {
        this.docs = response.data.docs.filter(d =>
          this.$store.getters["projects/get"](d.project)
        );
      })
      .catch(error => console.log(error));
  }
};
</script>

<style lang="scss" scoped>
.day-of-week {
  width: calc(100% / 7);
  justify-content: center;
}
// Griglia 5x7 per la visualizzazione del mese
.grid-container {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(5, 1fr);
  border-right: 1px solid #bbb;
  border-bottom: 1px solid #bbb;
  background-color: #f9f9f9;
}
// Stile di una cella (grid-item) corrispondente ad un giorno
.grid-cell {
  height: 105px;
  min-width: calc(100% / 7);
  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
}
.day-block {
  height: 100%;
  flex-direction: column;
  flex-wrap: nowrap;
  padding: 0 2px;
  cursor: pointer;
  &.other-month {
    opacity: 0.4;
  }
  &:hover {
    background-color: #eee;
  }
}
.day-projects-div {
  height: 100%;
  & div {
    height: calc(100% / 6);
    padding: 1px 2px;
  }
}
.project-label {
  flex-wrap: nowrap;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 2px;
  background-color: #fff;
}
</style>
